export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b9e2f2766f8289013d125bc88a6bc218.jpg"
          alt="Technology Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center w-full">
        <div className="inline-block mb-6 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
          <span className="text-white text-sm font-medium">Trusted by 100+ Enterprises</span>
        </div>

        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Transform Your<br />
          Network Infrastructure<br />
          <span className="text-teal-400">With AI-Powered Solutions</span>
        </h1>

        <p className="text-xl md:text-2xl text-gray-200 mb-10 max-w-3xl mx-auto">
          End-to-end network automation, cloud consulting, and cutting-edge AI/ML training programs
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => scrollToSection('contact')}
            className="px-8 py-4 bg-gradient-to-r from-teal-500 to-teal-600 text-white text-lg font-semibold rounded-lg hover:from-teal-600 hover:to-teal-700 transition-all cursor-pointer whitespace-nowrap shadow-lg"
          >
            Schedule Free Assessment
          </button>
          <button
            onClick={() => scrollToSection('services')}
            className="px-8 py-4 bg-transparent border-2 border-white text-white text-lg font-semibold rounded-lg hover:bg-white hover:text-gray-900 transition-all cursor-pointer whitespace-nowrap"
          >
            Explore Services <i className="ri-arrow-right-line ml-2"></i>
          </button>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-20 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="text-5xl font-bold text-white mb-2">25+</div>
            <div className="text-gray-200 text-sm">Years Experience</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="text-5xl font-bold text-white mb-2">100+</div>
            <div className="text-gray-200 text-sm">Projects Completed</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
            <div className="text-5xl font-bold text-white mb-2">98%</div>
            <div className="text-gray-200 text-sm">Client Satisfaction</div>
          </div>
        </div>
      </div>
    </section>
  );
}
